module.exports = __webpack_public_path__ + "static/38-b410dba9afb467fabf01474900da5a57.jpg";